type BadgeProps = {
  children: React.ReactNode;
  className?: string;
};

const Badge = (props: BadgeProps) => {
  const { className } = props;
  return (
    <span className={`text-sm bg-gray-300 rounded-2xl p-2 ${className ?? ""}`}>
      {props.children}
    </span>
  );
};

export default Badge;
